import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BaseUrl } from "../helper/apiHelper";
import toast from "react-hot-toast";
import logo from "../assets/login_logo.png";
import main_img from "../assets/222222222.jpg";

const SignInLayer = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordType, setPasswordType] = useState("password");
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  /* =========================
     LOAD REMEMBERED EMAIL
  ========================= */
  useEffect(() => {
    const savedEmail = localStorage.getItem("rememberEmail");
    if (savedEmail) {
      setEmail(savedEmail);
      setRememberMe(true);
    }
  }, []);

  const handlePasswordToggle = () => {
    setPasswordType((prev) => (prev === "password" ? "text" : "password"));
  };

  const handleSignInClick = async () => {
    setLoading(true);
    try {
      if (!email) {
        toast.error("Please enter email");
        return;
      }
      if (!password) {
        toast.error("Please enter password");
        return;
      }

      const body = { email, password };
      const response = await axios.post(`${BaseUrl}/master-admin-signin`, body);

      if (response.status === 200) {
        // Remember email logic
        if (rememberMe) {
          localStorage.setItem("rememberEmail", email);
        } else {
          localStorage.removeItem("rememberEmail");
        }

        localStorage.setItem("accessToken", response.data.token);
        localStorage.setItem(
          "mastercreds",
          JSON.stringify(response.data.userData)
        );

        navigate("/dashboard");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Sign in failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="auth bg-base d-flex flex-wrap">
      <div
        className="auth-left d-lg-block d-none"
        style={{ height: "100vh", width: "50%" }}
      >
        <img
          src={main_img}
          alt=""
          style={{ height: "100%", width: "100%", objectFit: "cover" }}
        />
      </div>

      <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
        <div className="max-w-464-px mx-auto w-100">
          <div>
            <Link to="/" className="mb-40 max-w-290-px d-flex" style={{marginLeft:"-20px"}}>
              <img src="/ship_logo.svg" alt="Logo" />
            </Link>
            <h4 className="mb-12">Sign In to your Account</h4>
            <p className="mb-32 text-secondary-light text-lg">
              Welcome back! Please enter your details
            </p>
          </div>

          <form>
            {/* EMAIL */}
            <div className="icon-field mb-16">
              <span className="icon top-50 translate-middle-y">
                <Icon icon="mage:email" />
              </span>
              <input
                type="email"
                className="form-control h-56-px bg-neutral-50 radius-12"
                placeholder="Enter Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            {/* PASSWORD */}
            <div className="position-relative mb-20">
              <div className="icon-field">
                <span className="icon top-50 translate-middle-y">
                  <Icon icon="solar:lock-password-outline" />
                </span>
                <input
                  type={passwordType}
                  className="form-control h-56-px bg-neutral-50 radius-12"
                  placeholder="Enter Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <button
                type="button"
                className="toggle-password cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light border-0 bg-transparent"
                onClick={handlePasswordToggle}
              >
                <i
                  className={`ri-${
                    passwordType === "password" ? "eye-line" : "eye-off-line"
                  }`}
                ></i>
              </button>
            </div>

            {/* REMEMBER ME */}
            <div className="form-check style-check d-flex align-items-center mb-24">
              <input
                className="form-check-input border border-neutral-300"
                type="checkbox"
                id="remember"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              <label className="form-check-label ms-8" htmlFor="remember">
                Remember me
              </label>
            </div>

            {/* SUBMIT */}
            <button
              type="button"
              onClick={handleSignInClick}
              className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" />
                  Signing In...
                </>
              ) : (
                "Sign In"
              )}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default SignInLayer;
